<template>
  <img
    src="https://static.lingvisions.com/public/fceeaf265be94500b882da44cebf00da.png"
    :class="$style.Container"
  />
</template>

<style lang="less" module>
  .Container {
    width: 44px;
    height: 20px;
    display: block;
    border-top-right-radius: 6px;
  }
</style>
